<template>
  <div>
    <div class="col-lg-12 text-center mt-5 mb-2">
      <span><h2><b>Reporte de Ventas{{nameMarca}}</b></h2></span>
    </div>
    <!-- {{jsondata}} -->
    <div class="center">
      <!-- {{ dateI }}
      {{ dateF }} -->
      <input type="date" v-model="dateI" name="fechaInicial">
      <input type="date" v-model="dateF" name="fechaFinal" class="mt-1 ml-2">
      <button class="btn btn-secondary ml-3" @click="loadItems" :disabled="showButton">Buscar</button>
    </div>
    <div class="row justify-content-center mt-3">
        <div class="mt-2 col-lg-3 text-center">
          <b>Total de Venta: $ {{totalGeneral | formatNumberCurrency}}</b>
        </div>
        <div class="mt-2 col-lg-3 text-center">
          <b>Total de Creditos: $ {{totalNotas | formatNumberCurrency}}</b>
        </div>
        <div class="mt-2 col-lg-3 text-center">
          <b>Total de Abonos: $ {{totalAbonosCreados | formatNumberCurrency}}</b>
        </div>
        <div class="mt-2 col-lg-3 text-center">
          <b>Total de Ajuste: $ {{totalAjustesCreados | formatNumberCurrency}}</b>
        </div>
        <div class="mt-2 col-lg-3 text-center">
          <b>Total de Efectivo: $ {{totalEfectivo | formatNumberCurrency}}</b>
        </div>
        <div class="mt-2 col-lg-3 text-center">
          <b>Total de Tarjeta: $ {{totalTarjeta | formatNumberCurrency}}</b>
        </div>
        <div class="mt-2 col-lg-3 text-center">
          <b>Total de Transferencia: $ {{totalTransferencia | formatNumberCurrency}}</b>
        </div>
        <div class="mt-2 col-lg-3 text-center">
          <b>Total de Comisiones: $ {{totalComisiones | formatNumberCurrency}}</b>
        </div>
    </div>
    <template>
      <div class="row justify-content-end mb-4 mt-4">
        <jsonExcel :data="jsondata"
          class="btn btn-secondary"
          :fields= "{
            'Folio': 'invoice',
            'Tipo': 'type',
            'Productos': 'numeroProductos',
            'Cliente': 'client',
            'Fecha': 'date',
            'Total Venta': 'total',
            'Creditos': 'creditos',
            'Tarjeta': 'tarjeta',
            'Transferencia': 'transferencia',
            'Comisión': 'comision',
            'Efectivo': 'efectivo',
          }"
          worksheet="Reporte de ventas"
          name="Reporte de ventas.xls"
        >
          Descargar a Excel
        </jsonExcel>
        </div>
      <vue-good-table
      :columns="columns"
      :rows="jsondata"
      :isLoading="loader"
      :totalRows="totalRecords"
      :sort-options="{
          enabled: true
        }"
        :pagination-options="{
                    enabled: true,
                    mode: 'registros',
                    position: 'top',
                    perPage: 10,
                    nextLabel: 'siguiente',
                    prevLabel: 'anterior',
                    rowsPerPageLabel: 'Filas por página',
                    ofLabel: 'de',
                    pageLabel: 'páginas', // for 'pages' mode
                    allLabel: 'Todos',
                  }"
              :select-options="{ enabled: false }"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
      :row-style-class="rowStyleClassFn"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'config'" @click="ShowDetail(props.row)" class="btn btn-primary">
              Detalle
          </span>
        </template>
      </vue-good-table>
    </template>
    <modal name="DetalleVenta" :adaptive="true" :scrollable="true" height="auto" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('DetalleVenta')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center reset-pass">
        <h2>Detalle de Venta </h2>
        {{ detalleVentaGeneral.efectivo }}
        <h5>{{detailStocktaking[0].client}}</h5>
        <div class="mt-3 col-lg-12">
          <table class="">
            <tr>
              <th>Código</th>
              <th>Producto</th>
              <th>Talla</th>
              <th>Cantidad</th>
              <th>Precio</th>
              <th>Descuento</th>
              <th>Total</th>
            </tr>
            <tr v-for="item in itemsInventarioDetail" :key="item.order_id">
              <td>{{item.barcode}}</td>
              <td>{{item.product}}</td>
              <td>{{item.numero}}</td>
              <td>{{item.cantidad}}</td>
              <td>$ {{item.precio | formatNumberCurrency}}</td>
              <td>{{item.porcentaje_descuento}} %</td>
              <td>$ {{item.total | formatNumberCurrency}}</td>
            </tr>
          </table>
          <div class="row justify-content-end mr-5 mt-3">
            <table >
              <tr>
                <td align="left">
                  <b>Total de productos</b>
                </td>
                <td align="right">
                  <b style="color: blue">$ {{detalleVentaGeneral.amount | formatNumberCurrency}}</b>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <b>Descuentos</b>
                </td>
                <td align="right">
                  <b style="color: blue">$ {{detalleDescuentosVenta | formatNumberCurrency}}</b>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <b>Subtotal</b>
                </td>
                <td align="right">
                  <b style="color: blue">$ {{(detalleVentaGeneral.amount - detalleDescuentosVenta) | formatNumberCurrency}}</b>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <b>Abonos</b>
                </td>
                <td align="right">
                  <b style="color: blue">$ {{detalleVentaGeneral.totalAbonos | formatNumberCurrency}}</b>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <b>Vales</b>
                </td>
                <td align="right">
                  <b style="color: blue">$ {{detalleVentaGeneral.totalVales | formatNumberCurrency}}</b>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <b>Total de Venta</b>
                </td>
                <td align="right">
                  <b style="color: blue">$ {{detalleVentaGeneral.efectivo | formatNumberCurrency}}</b>
                </td>
              </tr>
            </table>
          </div>
          <!-- <div class="col-lg-12 text-right mt-3">
            <b>Total de productos: $ {{detalleVentaGeneral.amount | formatNumberCurrency}}</b>
          </div>
          <div class="col-lg-12 text-right mt-1">
            <b>Descuentos: $ {{detalleDescuentosVenta | formatNumberCurrency}}</b>
          </div>
          <div class="col-lg-12 text-right mt-3">
            <b>Subtotal: $ {{detalleVentaGeneral.amount | formatNumberCurrency}}</b>
          </div>
          <div class="col-lg-12 text-right mt-1">
            <b>Abonos: $ {{detalleVentaGeneral.totalAbonos | formatNumberCurrency}}</b>
          </div>
          <div class="col-lg-12 text-right mt-1">
            <b>Vales: $ {{detalleVentaGeneral.totalVales | formatNumberCurrency}}</b>
          </div>
          <div class="col-lg-12 text-right mt-1">
            <b>Total de Venta: $ {{detalleVentaGeneral.efectivo | formatNumberCurrency}}</b>
          </div> -->
          <!-- <div class="col-lg-12 text-right mt-1" v-for="a in detalleVentaGeneral.abonos" :key="a.id_abono">
            <b>Abono {{a.barcode}}: $ {{a.amount | formatNumberCurrency}}</b>
          </div>
          <div class="col-lg-12 text-right mt-1" v-for="a in detalleVentaGeneral.devolutions" :key="a.id_abono">
            <b>Vale {{a.barcode}}: $ {{a.amount | formatNumberCurrency}}</b>
          </div> -->
          <div class="col-lg-12 text-right mt-1" v-if="detalleVentaGeneral.total_cancelaciones > 0">
            <b>Cancelaciones: $ {{detalleVentaGeneral.total_cancelaciones | formatNumberCurrency}}</b>
          </div>
          <h6>Detalle de pago</h6>
          <div class="row justify-cointent-start ml-3">
            <table>
              <tr>
                <td align="left">
                  <b>Pago en efectivo:</b>
                </td>
                <td align="right">
                  <b style="color: green;">$ {{ (detalleVentaGeneral.efectivo) | formatNumberCurrency }}</b>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <b>Total en cambio:</b>
                </td>
                <td align="right">
                  <b style="color: green;">$ {{ (detalleVentaGeneral.cambio) | formatNumberCurrency }}</b>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <b>Pago con transferencia:</b>
                </td>
                <td align="right">
                  <b style="color: green;">$ {{ (detalleVentaGeneral.transferencia) | formatNumberCurrency }}</b>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <b>Pago con tarjeta:</b>
                </td>
                <td align="right">
                  <b style="color: green;">$ {{ (detalleVentaGeneral.tarjeta) | formatNumberCurrency }}</b>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <b>Total en comision:</b>
                </td>
                <td align="right">
                  <b style="color: green;">$ {{ (detalleVentaGeneral.comision) | formatNumberCurrency }}</b>
                </td>
              </tr>
              <tr v-for="(a, index) in detalleVentaGeneral.abonos" :key="index">
                <td align="left">
                  <b>Abono {{ a.barcode }}:</b>
                </td>
                <td align="right">
                  <b style="color: green;">$ {{ (a.amount) | formatNumberCurrency }}</b>
                </td>
              </tr>
              <tr v-for="(a, index) in detalleVentaGeneral.devolutions" :key="index">
                <td align="left">
                  <b>Vale {{ a.barcode }}:</b>
                </td>
                <td align="right">
                  <b style="color: green;">$ {{ (a.amount) | formatNumberCurrency }}</b>
                </td>
              </tr>
            </table>
            <!-- <div class="row col-6">
              <b>Pago en efectivo: {{ (detalleVentaGeneral.efectivo + detalleVentaGeneral.cambio) | formatNumberCurrency }}</b>
              <b>Total en cambio: {{ detalleVentaGeneral.cambio | formatNumberCurrency }}</b>
              <b>Pago con transferencia: {{ detalleVentaGeneral.transferencia | formatNumberCurrency }}</b>
              <b>Pago con tarjeta: {{ detalleVentaGeneral.tarjeta | formatNumberCurrency }}</b>
              <b>Total en comision: {{ detalleVentaGeneral.comision | formatNumberCurrency }}</b>
            </div> -->
          </div>
          <div class="row mt-5 mb-3 justify-content-center">
            <div class="col-lg-6">
              <button v-if="$can('config', 'Reportes')" class="btn btn-orange" style="background:red;" @click="cancelarCompra(detailStocktaking[0].invoice)">Cancelar compra</button>
            </div>
            <div class="col-lg-3">
              <button class="btn btn-orange" @click="getLastSales(detailStocktaking[0].invoice)">Imprimir</button>
            </div>
          </div>
          <!-- {{detalleVentaGeneral}} -->
        </div>
      </div>
    </modal>
    <ticket :ticket="ticketDeCompra" :enterprise="enterpriseData.name" :print="countPrint"/>
    <!-- IMPRESION TICKET DE COMPRA -->
    <!-- <div class="mt-3">
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="300"
          :filename="`Ticket de compra-${ticket}`"
          :pdf-quality="2"
          :manual-pagination="true"
          :htmlToPdfOptions = "htmlToPdfOptions"
          pdf-format="b6"
          pdf-orientation="portrait"
          pdf-content-width="100%"
          @progress="onProgress($event)"
          @startPagination="startPagination()"
          @hasPaginated="hasPaginated()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
        >
        <section slot="pdf-content" style="width: 75mm !important;">
            <div class="container ticket" style="width: 75mm !important">
              <div class="row justify-content-center">
                <div class="mt-4 col-lg-10 text-center line1">
                  <p><b>Ticket de compra</b></p>
                </div>
              </div>
              <div class="mt-2 col-lg-10 text-center">
                <p><b>{{enterpriseData.name}}</b></p>
              </div>
              <div class="mt-1 ml-3 bodyLineHeigth line1 detailFront">
                <p>Folio: {{ultimaVenta.generals !== undefined ? ultimaVenta.generals.invoice : 0 }}</p>
                <p>Fecha: {{ultimaVenta.generals !== undefined ? ultimaVenta.generals.date: ''}}</p>
                <p>Cliente: {{ultimaVenta.generals !== undefined ? ultimaVenta.rows[0].name_client : ''}}</p>
                <p>ATENDIO: {{user.name + ' ' + user.last_name_1 + ' ' + user.last_name_2}}</p>
              </div>
            </div>
            <div class="mt-2 text-center line1">
              Total de productos: {{ultimaVenta.totalRecords}}
            </div>
            <div class="row justify-content-center mt-4 bodyPrintAbono line1" style="width: 70mm !important;">
              <div class="col-lg-11">
                <table style="border: .5px solid #999; padding: 0px;" class="bodyLineHeigth">
                  <tr class="text-center tableXD">
                    <td style="height: 5px;">Codigo<br />Descripción</td>
                    <td>Precio</td>
                    <td>Desc.</td>
                    <td>Total</td>
                  </tr>
                  <tr class="text-right" v-for="(v, index) in ultimaVenta.rows" :key="index" style="font-size: 7px;">
                    <td class="line1" style="font-size: 6px;">{{v.barcode}}<br/>{{v.product}}</td>
                    <td class="line1" style="font-size: 6px;">$ {{v.precio | formatNumberCurrency}}</td>
                    <td class="line1" style="font-size: 6px;">{{v.porcentaje_descuento}} %</td>
                    <td class="line1" style="font-size: 6px;">$ {{v.venta | formatNumberCurrency}}</td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-right line1" style="font-size: 8px;">
                      TOTAL DE PRODUCTOS:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 8px;">
                      <b>$ {{ultimaVentaReales.totalCompra | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-right line1" style="font-size: 8px;">
                      DESCUENTO:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 8px;">
                      <b>$ {{ultimaVentaReales.descuento | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-right line1" style="font-size: 8px;">
                      SUBTOTAL:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 8px;">
                      <b>$ {{(ultimaVentaReales.amount) | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <tr v-if="ultimaVentaReales.totalAbonos > 0">
                    <td colspan="2" class="text-right line1" style="font-size: 8px;">
                      Abonos:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 8px;">
                      <b>$ {{ultimaVentaReales.totalAbonos | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <tr v-if="ultimaVentaReales.totalNotas > 0">
                    <td colspan="2" class="text-right line1" style="font-size: 8px;">
                      Notas:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 8px;">
                      <b>$ {{ultimaVentaReales.totalNotas | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <tr v-if="ultimaVentaReales.total_cancelaciones > 0">
                    <td colspan="2" class="text-right line1" style="font-size: 8px;">
                      Cancelaciones:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 8px;">
                      <b>$ {{ultimaVentaReales.total_cancelaciones | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-right" style="font-size: 8px;">
                      TOTAL:
                    </td>
                    <td colspan="2" class="text-right" style="font-size: 8px;">
                      <b>$ {{ultimaVentaReales.total | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="row">
                <table class="mt-3">
                  <tr class="text-center">
                    <td colspan="2 text-center">
                      Detalle de Pago
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size: 6px;">Pago con tarjeta</td>
                    <td style="font-size: 6px;">$ {{ultimaVenta.reales === undefined ? 0 : ultimaVenta.reales.tarjeta}}</td>
                  </tr>
                  <tr style="font-size: 6px;">
                    <td style="font-size: 6px;">Comisión</td>
                    <td style="font-size: 6px;">$ {{ultimaVenta.reales === undefined ? 0 : ultimaVenta.reales.comision}}</td>
                  </tr>
                  <tr style="font-size: 6px;">
                    <td style="font-size: 6px;">Total en Efectivo</td>
                    <td style="font-size: 6px;">$ {{ultimaVenta.reales === undefined ? 0 : ultimaVenta.reales.efectivo}}</td>
                  </tr>
                  <tr style="font-size: 7px;" v-if="ultimaVentaReales !== undefined && ultimaVentaReales.efectivo > 0">
                    <td style="font-size: 7px;">Pago en Efectivo</td>
                    <td style="font-size: 7px;">$ {{ultimaVentaReales === undefined ? 0 : ultimaVentaReales.efectivo + ultimaVentaReales.cambio | formatNumberCurrency}}</td>
                  </tr>
                  <tr style="font-size: 6px;">
                    <td style="font-size: 6px;">Cambio</td>
                    <td style="font-size: 6px;">$ {{ultimaVenta.reales === undefined ? 0 : ultimaVenta.reales.cambio}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="row justify-content-center mt-4">
                <div class="col-lg-10 text-center footerTicket">
                  <p>Gracias por su preferencia</p>
                  <p>Teléfonos</p>
                  <p v-for="(p, index) in footer.phones" :key="index">{{p.phone}}</p>
                </div>
              </div>
              <div class="row footerTicket mt-4">
                <div class="col-lg-10">
                  <p>{{footer.texto}}</p>
                </div>
              </div>
          </section>
        </vue-html2pdf>
      </div> -->
  </div>
</template>

<script>
// import { BTable } from 'bootstrap-vue'
// import VueHtml2pdf from 'vue-html2pdf'
// import VueBarcode from 'vue-barcode'
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import moment from 'moment'
import JsonExcel from 'vue-json-excel'
import { mapGetters } from 'vuex'
import ticket from './ticket.vue'
moment.locale('es')
// const axios = require('axios')
// var https = require('https')
export default {
  props: ['marca'],
  mixins: [formatData],
  components: {
    VueGoodTable,
    ticket,
    JsonExcel
    // VueHtml2pdf
    // VueBarcode
    // BTable
  },
  data () {
    return {
      loader: true,
      showButton: false,
      countPrint: 0,
      ticketDeCompra: 0,
      totalAbonosCreados: 0,
      totalAjustesCreados: 0,
      ticket: [],
      enterpriseData: [],
      ultimaVentaReales: {
        amount: 0,
        descuento: 0
      },
      ultimaVenta: [],
      detalleInvoice: [],
      detalleTotalVenta: 0,
      detalleDescuentosVenta: 0,
      detalleVentaGeneral: [],
      dateI: moment().format('YYYY-MM-DD'),
      dateF: moment().format('YYYY-MM-DD'),
      totalGeneral: 0,
      totalEfectivo: 0,
      totalTarjeta: 0,
      totalTransferencia: 0,
      totalComisiones: 0,
      totalNotas: 0,
      totalGeneralString: 0,
      nameMarca: '',
      rows: [],
      itemsInventarioDetail: [],
      isLoading: false,
      id_provider: 0,
      jsondata: [],
      detailStocktaking: [{
        client: '',
        statusName: '',
        cantidad: '',
        date: '',
        id_client: 0
      }],
      optionsMarca: [],
      optionsEnterprise: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'Folio',
          field: 'invoice',
          type: 'number'
          // filterOptions: {
          //   placeholder: 'Codigo de barras',
          //   enabled: true
          // }
        },
        {
          label: 'Tipo',
          field: 'type'
          // filterOptions: {
          //   placeholder: 'Codigo de barras',
          //   enabled: true
          // }
        },
        {
          label: 'Productos',
          field: 'numeroProductos'
          // filterOptions: {
          //   placeholder: 'Producto',
          //   enabled: true
          // }
        },
        {
          label: 'Cliente',
          field: 'client',
          filterOptions: {
            placeholder: 'Cliente',
            enabled: true
          }
        },
        {
          label: 'Fecha',
          field: 'date',
          formatFn: this.formatDate
        },
        // {
        //   label: 'Proveedor',
        //   field: 'providerName'
        //   // filterOptions: {
        //   //   placeholder: 'Proveedor',
        //   //   enabled: true
        //   // }
        // },
        {
          label: 'Total Venta',
          field: 'total',
          formatFn: this.formatCurrency
        },
        {
          label: 'Creditos',
          field: 'creditos',
          formatFn: this.formatCurrency
        },
        {
          label: 'Tarjeta',
          field: 'tarjeta'
        },
        {
          label: 'Transferencia',
          field: 'transferencia',
          formatFn: this.formatCurrency
        },
        {
          label: 'Comisión',
          field: 'comision',
          formatFn: this.formatCurrency
        },
        {
          label: 'Efectivo',
          field: 'efectivo',
          formatFn: this.formatCurrency
        },
        {
          label: 'Detalle Venta',
          field: 'config'
        }
      ],
      fields: [
        { key: 'date', label: 'Fecha', sortable: true, sortDirection: 'desc' },
        { key: 'barcode', label: 'Codigo', sortable: true, sortDirection: 'desc' },
        { key: 'product', label: 'Producto', sortable: true, sortDirection: 'desc' },
        { key: 'cantidad', label: 'Cantidad', sortable: true, sortDirection: 'desc' },
        { key: 'precio', label: 'Precio', sortable: true, sortDirection: 'desc' },
        { key: 'total', label: 'Total', sortable: true, sortDirection: 'desc' }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      htmlToPdfOptions: {
        margin: 0,
        // margin: 0,
        // image: {
        //   type: 'jpeg',
        //   quality: 0.98
        // },
        // enableLinks: false,
        html2canvas: {
          scale: 3,
          useCORS: true
        }
        // jsPDF: {
        //   unit: 'mm',
        //   format: 'b10',
        //   orientation: 'portrait'
        // }
      },
      footer: {
        phones: [],
        texto: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    horaActual () {
      return moment.utc().format('HH:mm:ss')
    }
  },
  methods: {
    rowStyleClassFn (row) {
      console.log('rowStyleClassFn', row)
      return row.cancel ? 'red' : 'green'
    },
    formatDate (val) {
      return moment(val).format('YYYY-MM-DD')
    },
    formatCurrency (val) {
      return '$ ' + this.$formatNumberCurrency(val)
    },
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      // this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      // this.loadItems()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      // this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      // this.loadItems()
    },
    async loadItems (marca) {
      try {
        this.loader = true
        this.showButton = true
        this.jsondata = []
        this.totalGeneral = 0
        this.totalEfectivo = 0
        this.totalGeneralString = 0
        this.totalComisiones = 0
        this.totalTarjeta = 0
        this.totalTransferencia = 0
        this.totalAjustesCreados = 0
        this.totalNotas = 0
        this.totalAbonosCreados = 0
        const items = {
          dateI: this.dateI,
          dateF: this.dateF,
          enterprise_id: this.user.enterprise_id
        }
        console.log('lleva esto', items)
        const response = await axiosAdelaService.post('/getSales', items)
        console.log('getSales', response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          // if (this.totalRecords > 0) {
          const data = response.data.invoices
          const abonos = response.data.abonos
          const ajustes = response.data.ajustes
          this.detalleInvoice = response.data.detalle
          console.log('response.data.rows', response)
          // for (const key in data) {
          //   this.totalEfectivo += parseFloat(data[key].detail === undefined ? 0 : data[key].detail.efectivo)
          // }
          console.log('this.totalEfectivo  primea vuelta', this.totalEfectivo)
          data.forEach(el => {
            console.log(el)
            if (el.cancel === 0) {
              this.totalGeneral += parseFloat(el.total)
              this.totalEfectivo += parseFloat(el.detail === undefined ? 0 : el.detail.efectivo - el.cambio)
              this.totalComisiones += parseFloat(el.detail === undefined ? 0 : el.detail.comision)
              this.totalTarjeta += parseFloat(el.detail === undefined ? 0 : el.detail.tarjeta)
              this.totalTransferencia += parseFloat(el.detail === undefined ? 0 : el.detail.transferencia)
              this.totalNotas += parseFloat(el.detail === undefined ? 0 : el.detail.totalAbonos)
              this.totalGeneralString += parseFloat(el.total).toFixed(2)
            }
            this.jsondata.push({
              invoice: el.invoice,
              numeroProductos: el.orders === undefined ? 0 : el.orders.length,
              barcode: el.barcode,
              product: el.product,
              providerName: el.providerName,
              total: '$ ' + el.detail.total,
              date: el.date,
              detail: el.detail,
              tarjeta: el.detail === undefined ? 0 : el.detail.tarjeta,
              transferencia: el.detail === undefined ? 0 : el.detail.transferencia,
              efectivo: (el.detail === undefined ? 0 : (el.detail.efectivo - el.cambio)).toFixed(2),
              cambio: el.detail === undefined ? 0 : el.cambio,
              comision: el.detail === undefined ? 0 : el.detail.comision,
              creditos: el.detail.totalAbonos,
              client: el.client,
              type: 'Venta',
              cancel: el.cancel
            })
          })
          abonos.forEach(el => {
            this.totalAbonosCreados += el.amount
            this.totalEfectivo += el.amount
            this.jsondata.push({
              invoice: el.id_abono,
              numeroProductos: 0,
              barcode: el.barcode,
              product: 'ABONO',
              client: el.client_name,
              providerName: '',
              total: 0,
              date: moment(el.create_at).format('YYYY-MM-DD'),
              detail: [],
              tarjeta: 0,
              efectivo: el.amount,
              comision: 0,
              creditos: 0,
              type: 'Abono'
            })
          })
          ajustes.forEach(el => {
            this.totalAjustesCreados += el.amount
            this.jsondata.push({
              invoice: el.id_abono,
              numeroProductos: 0,
              barcode: el.barcode,
              product: 'AJUSTE',
              client: el.client_name,
              providerName: '',
              total: 0,
              date: moment(el.create_at).format('YYYY-MM-DD'),
              detail: [],
              tarjeta: 0,
              efectivo: el.amount,
              comision: 0,
              creditos: 0,
              type: 'Ajuste'
            })
          })
          // } else {
          //   this.$toastedPush({
          //     message: 'No existen ventas para este rango de fecha',
          //     type: 'error'
          //   })
          // this.$router.push({ name: 'stocktaking' })
          // }
          this.showButton = false
          this.loader = false
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudo obtener los datos, por favor intentelo más tarde.')
      }
    },
    async ShowDetail (...args) {
      console.log(args)
      this.detailStocktaking = args
      await this.detalleVenta(args[0])
      this.$modal.show('DetalleVenta')
    },
    async detalleVenta (args) {
      try {
        this.detalleTotalVenta = 0
        this.detalleVentaGeneral = []
        this.itemsInventarioDetail = []
        const items = {
          enterprise_id: this.user.enterprise_id,
          invoice: args.invoice
        }
        const response = await axiosAdelaService.post('/detalleVentaForInvoice', items)
        console.log('detalleVentaForInvoiuce', response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          const detalleXY = response.data.detalle
          console.log('Este es el detalle', detalleXY)
          if (this.totalRecords > 0) {
            console.log('detalleVentaForInvoice', response.data)
            this.detalleVentaGeneral = response.data.detalle
            let totalAbonos = 0
            let totalVales = 0
            this.detalleVentaGeneral.abonos.forEach(el => {
              totalAbonos += el.amount
            })
            this.detalleVentaGeneral.devolutions.forEach(el => {
              console.log('*****  Este es el vale', el)
              totalVales += el.amount
            })
            this.detalleVentaGeneral.total = response.data.rows[0].total
            this.detalleVentaGeneral.totalAbonos = totalAbonos
            this.detalleVentaGeneral.totalVales = totalVales

            this.detalleDescuentosVenta = this.detalleVentaGeneral.descuento
            response.data.rows.forEach(el => {
              this.detalleTotalVenta += parseFloat(el.total)
              this.itemsInventarioDetail.push({
                barcode: el.barcode,
                client_id: el.client_id,
                date: el.date,
                invoice: el.invoice,
                name_client: el.name_client,
                order_id: el.order_id,
                product: el.product,
                providerName: el.providerName,
                sales_id: el.sales_id,
                total: '$ ' + el.total,
                userName: el.userName,
                user_id: el.user_id,
                cantidad: el.cantidad,
                precio: '$ ' + el.venta,
                descuento: el.descuento,
                porcentaje_descuento: el.porcentaje_descuento,
                client_name: el.client,
                totalVenta: '$ ' + el.totalVenta,
                numero: el.numero
              })
            })
          } else {
            this.$toastedPush({
              message: 'No existen mas registros para esta venta',
              type: 'error'
            })
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudo obtener el detalle de la venta, por favor intentelo más tarde.')
      }
    },
    cancelarCompra (invoice) {
      console.log('Cancelar compra')
      this.$dialog.confirm(`
        <div class="row justify-content-center">
          <div class="col-lg-10 text-center">
            <h4 style="color:red"><b>Por favor, confirma que deseas cancelar la compra. <br>Esta acción devolvera los productos a el inventario...</b></h4>
          </div>
        </div>
      `)
        .then(async () => {
          const request = {
            invoice: invoice,
            enterprise: this.user.enterprise_id
          }
          const response = await axiosAdelaService.post('/cancelSales', request)
          console.log(response)
        })
        .catch((err) => {
          console.log('presiono cancelar confirmationDialog', err)
        })
    },
    async getLastSales (invoice) {
      this.ticketDeCompra = invoice
      this.countPrint++
      // console.log('entro a este pedo')
      // this.ultimaVenta = []
      // this.totalProductos = 0
      // const request = {
      //   invoice: invoice,
      //   // invoice: 1,
      //   id_empresa: this.user.enterprise_id
      // }
      // const response = await axiosAdelaService.post('/getLastSales', request)
      // console.log('getLastSales', response)
      // if (response.status === 200) {
      //   this.ultimaVenta = response.data
      //   this.ultimaVentaReales = response.data.reales
      //   let totalVenta = 0
      //   let descuento = 0
      //   this.ultimaVenta.rows.forEach(el => {
      //     totalVenta += el.precio
      //     descuento += el.descuento
      //   })
      //   this.ultimaVenta.generals.date = moment(response.data.generals.date).format('YYYY-MM-DD')
      //   this.ultimaVenta.subtotal = this.getFormattedAmount(totalVenta)
      //   this.ultimaVenta.descuento = this.getFormattedAmount(descuento)
      //   this.ultimaVenta.total = this.getFormattedAmount(totalVenta - descuento)
      //   this.ultimaVentaReales.totalCompra = totalVenta
      //   // console.log(this.$formatCurrencyToText(totalVenta - descuento))
      // this.$refs.html2Pdf.generatePdf()
      // }
    },
    onProgress (progress) {
      this.progress = progress
      console.log(`PDF generation progress: ${progress}%`)
    },
    startPagination () {
      console.log('PDF has started pagination')
    },
    hasPaginated () {
      console.log('PDF has been paginated')
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      console.log('On Before PDF Generation')
    },
    hasDownloaded (blobPdf) {
      console.log('PDF has downloaded yehey')
      this.pdfDownloaded = true
      console.log(blobPdf)
    },
    getFormattedAmount (amount) {
      if (amount) {
        return '$ ' + this.$formatNumberCurrency(amount, 'MXN')
      } else {
        return ''
      }
    },
    async getCurrentEnterprise () {
      try {
        const request = {
          data: this.user.enterprise_id
        }
        const orders = await axiosAdelaService.post('/getEnterprisesSelected', request)
        console.log('getEnterprisesSelected', orders)
        if (orders.status === 200) {
          this.enterpriseData = orders.data.rows[0]
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getFooterTicket () {
      try {
        const request = {
          enterprise_id: this.user.enterprise_id
        }
        const footer = await axiosAdelaService.post('/getFooterTicket', request)
        if (footer.status === 200) {
          console.log('footer', footer)
          this.footer.phones = footer.data.phones
          this.footer.texto = footer.data.textoFooter
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    }
  },
  async mounted () {
    await this.getCurrentEnterprise()
    await this.getFooterTicket()
    await this.loadItems(this.$route.params)
    this.nameMarca = this.$route.params.marca
    this.id_provider = this.$route.params.id_provider === undefined ? this.$route.params.id_provider : 0
  }
}
</script>

<style>
.btnGenerateBuy {
  display: inline-block;
}

.detailFront p {
  font-size: 10px;
  line-height: 16.5pt !important;
  margin-bottom: 0px !important;
  margin: 0 !important;
}
.green {
  background: rgb(170, 212, 170);
}
.green .table.vgt-table td {
  color: white !important;
}
.red {
  background: rgb(234, 173, 173);
}
</style>
